// Member World Level Configurations (M1-M50)
// Exclusive world for Premium Members
// Features: 2x coins, special rewards, unique mechanics, exclusive boss

// Member World Theme: Crystal Paradise
// A magical crystal dimension with premium-exclusive features
// No life cost, bonus rewards, special golden fruits

export const MEMBER_WORLD_CONFIG = {
  id: "member_world",
  name: "Crystal Paradise",
  subtitle: "Member Exclusive",
  emoji: "💎",
  color: "#a855f7",
  unlockRequirement: "premium_membership",
  levelRange: [9001, 9050], // Special range for member world
  benefits: {
    coinMultiplier: 2.0,
    xpMultiplier: 1.2,
    noLifeCost: true,
    bonusRewards: true
  }
};

// Generate 50 member-exclusive levels
export const MEMBER_WORLD_LEVELS = [
  // Levels M1-M10: Crystal Gardens (Introduction)
  {
    id: 9001,
    name: "Crystal Garden I",
    subtitle: "Welcome, Member!",
    difficulty: "Medium",
    missionType: "collect_fruit",
    targetFruit: "grape",
    targetEmoji: "🍇",
    targetCount: 30,
    moves: 35,
    boardSize: 9,
    worldMechanic: "golden_fruits",
    goldenChance: 0.15,
    obstacles: { type: "crystal", crystal_block: 4 },
    bgColor: "from-purple-900 via-fuchsia-800 to-pink-700",
    borderColor: "border-purple-400",
    memberExclusive: true,
    rewards: { coins: 200, xp: 150 }
  },
  {
    id: 9002,
    name: "Crystal Garden II",
    subtitle: "Diamond Path",
    difficulty: "Medium",
    missionType: "reach_score",
    targetFruit: "star",
    targetEmoji: "⭐",
    targetScore: 8000,
    moves: 30,
    boardSize: 9,
    worldMechanic: "golden_fruits",
    goldenChance: 0.15,
    obstacles: { type: "crystal", crystal_block: 6 },
    bgColor: "from-violet-900 via-purple-800 to-fuchsia-700",
    borderColor: "border-fuchsia-400",
    memberExclusive: true,
    rewards: { coins: 250, xp: 175 }
  },
  {
    id: 9003,
    name: "Crystal Garden III",
    subtitle: "Sapphire Falls",
    difficulty: "Medium",
    missionType: "collect_fruit",
    targetFruit: "blueberry",
    targetEmoji: "🫐",
    targetCount: 35,
    moves: 32,
    boardSize: 9,
    worldMechanic: "golden_fruits",
    goldenChance: 0.18,
    obstacles: { type: "crystal", water_crystal: 5 },
    bgColor: "from-blue-900 via-indigo-800 to-purple-700",
    borderColor: "border-blue-400",
    memberExclusive: true,
    rewards: { coins: 275, xp: 200 }
  },
  {
    id: 9004,
    name: "Crystal Garden IV",
    subtitle: "Ruby Ridge",
    difficulty: "Medium",
    missionType: "collect_fruit",
    targetFruit: "cherry",
    targetEmoji: "🍒",
    targetCount: 40,
    moves: 30,
    boardSize: 9,
    worldMechanic: "golden_fruits",
    goldenChance: 0.18,
    obstacles: { type: "crystal", ruby_block: 6 },
    bgColor: "from-red-900 via-rose-800 to-pink-700",
    borderColor: "border-rose-400",
    memberExclusive: true,
    rewards: { coins: 300, xp: 225 }
  },
  {
    id: 9005,
    name: "Crystal Garden V",
    subtitle: "Emerald Grove",
    difficulty: "Medium",
    missionType: "clear_blockers",
    blockerType: "crystal_block",
    targetCount: 15,
    moves: 28,
    boardSize: 9,
    worldMechanic: "golden_fruits",
    goldenChance: 0.20,
    obstacles: { type: "crystal", crystal_block: 15, emerald: 4 },
    bgColor: "from-green-900 via-emerald-800 to-teal-700",
    borderColor: "border-emerald-400",
    memberExclusive: true,
    rewards: { coins: 350, xp: 250 }
  },
  {
    id: 9006,
    name: "Crystal Garden VI",
    subtitle: "Amethyst Cave",
    difficulty: "Medium",
    missionType: "reach_score",
    targetScore: 10000,
    moves: 28,
    boardSize: 9,
    worldMechanic: "golden_fruits",
    goldenChance: 0.20,
    obstacles: { type: "crystal", amethyst: 8 },
    bgColor: "from-purple-950 via-violet-900 to-indigo-800",
    borderColor: "border-violet-400",
    memberExclusive: true,
    rewards: { coins: 375, xp: 275 }
  },
  {
    id: 9007,
    name: "Crystal Garden VII",
    subtitle: "Topaz Temple",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "orange",
    targetEmoji: "🍊",
    targetCount: 45,
    moves: 30,
    boardSize: 10,
    worldMechanic: "golden_fruits",
    goldenChance: 0.22,
    obstacles: { type: "crystal", topaz: 10 },
    bgColor: "from-yellow-900 via-amber-800 to-orange-700",
    borderColor: "border-amber-400",
    memberExclusive: true,
    rewards: { coins: 400, xp: 300 }
  },
  {
    id: 9008,
    name: "Crystal Garden VIII",
    subtitle: "Opal Oasis",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "watermelon",
    targetEmoji: "🍉",
    targetCount: 35,
    moves: 28,
    boardSize: 10,
    worldMechanic: "golden_fruits",
    goldenChance: 0.22,
    obstacles: { type: "crystal", opal: 8, water_crystal: 4 },
    bgColor: "from-cyan-900 via-teal-800 to-emerald-700",
    borderColor: "border-cyan-400",
    memberExclusive: true,
    rewards: { coins: 425, xp: 325 }
  },
  {
    id: 9009,
    name: "Crystal Garden IX",
    subtitle: "Onyx Depths",
    difficulty: "Hard",
    missionType: "reach_score",
    targetScore: 12000,
    moves: 26,
    boardSize: 10,
    worldMechanic: "golden_fruits",
    goldenChance: 0.25,
    obstacles: { type: "crystal", onyx: 12 },
    bgColor: "from-slate-900 via-gray-800 to-zinc-700",
    borderColor: "border-slate-400",
    memberExclusive: true,
    rewards: { coins: 450, xp: 350 }
  },
  {
    id: 9010,
    name: "Crystal Guardian",
    subtitle: "First Boss",
    difficulty: "Boss",
    missionType: "boss_fight",
    bossConfig: {
      name: "Crystal Guardian",
      type: "crystal_guardian",
      hp: 800,
      phases: 2,
      attacks: ["crystal_rain", "gem_blast", "prism_beam"]
    },
    moves: 40,
    boardSize: 10,
    worldMechanic: "golden_fruits",
    goldenChance: 0.25,
    bgColor: "from-purple-950 via-fuchsia-900 to-pink-800",
    borderColor: "border-purple-500",
    memberExclusive: true,
    rewards: { coins: 1000, xp: 500, stars: 25 }
  },
  
  // Levels M11-M20: Diamond Caverns
  {
    id: 9011,
    name: "Diamond Cavern I",
    subtitle: "Sparkling Depths",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "apple",
    targetEmoji: "🍎",
    targetCount: 50,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.10,
    obstacles: { type: "diamond", diamond_block: 8 },
    bgColor: "from-sky-900 via-blue-800 to-indigo-700",
    borderColor: "border-sky-300",
    memberExclusive: true,
    rewards: { coins: 500, xp: 400 }
  },
  {
    id: 9012,
    name: "Diamond Cavern II",
    subtitle: "Glittering Halls",
    difficulty: "Hard",
    missionType: "reach_score",
    targetScore: 15000,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.12,
    obstacles: { type: "diamond", diamond_block: 10 },
    bgColor: "from-indigo-900 via-blue-800 to-cyan-700",
    borderColor: "border-indigo-300",
    memberExclusive: true,
    rewards: { coins: 550, xp: 425 }
  },
  {
    id: 9013,
    name: "Diamond Cavern III",
    subtitle: "Prismatic Path",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "banana",
    targetEmoji: "🍌",
    targetCount: 55,
    moves: 28,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.12,
    obstacles: { type: "diamond", prism: 6 },
    bgColor: "from-violet-900 via-purple-800 to-fuchsia-700",
    borderColor: "border-violet-300",
    memberExclusive: true,
    rewards: { coins: 600, xp: 450 }
  },
  {
    id: 9014,
    name: "Diamond Cavern IV",
    subtitle: "Brilliant Basin",
    difficulty: "Hard",
    missionType: "clear_blockers",
    blockerType: "diamond_block",
    targetCount: 20,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.15,
    obstacles: { type: "diamond", diamond_block: 20, geode: 4 },
    bgColor: "from-blue-950 via-indigo-900 to-violet-800",
    borderColor: "border-blue-300",
    memberExclusive: true,
    rewards: { coins: 650, xp: 475 }
  },
  {
    id: 9015,
    name: "Diamond Cavern V",
    subtitle: "Radiant Realm",
    difficulty: "Hard",
    missionType: "reach_score",
    targetScore: 18000,
    moves: 28,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.15,
    obstacles: { type: "diamond", radiant: 8 },
    bgColor: "from-cyan-900 via-sky-800 to-blue-700",
    borderColor: "border-cyan-300",
    memberExclusive: true,
    rewards: { coins: 700, xp: 500 }
  },
  {
    id: 9016,
    name: "Diamond Cavern VI",
    subtitle: "Luminous Labyrinth",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "strawberry",
    targetEmoji: "🍓",
    targetCount: 60,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.18,
    obstacles: { type: "diamond", luminous: 10 },
    bgColor: "from-pink-900 via-rose-800 to-red-700",
    borderColor: "border-pink-300",
    memberExclusive: true,
    rewards: { coins: 750, xp: 525 }
  },
  {
    id: 9017,
    name: "Diamond Cavern VII",
    subtitle: "Ethereal Edge",
    difficulty: "Expert",
    missionType: "reach_score",
    targetScore: 20000,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.18,
    obstacles: { type: "diamond", ethereal: 12 },
    bgColor: "from-slate-800 via-gray-700 to-zinc-600",
    borderColor: "border-slate-300",
    memberExclusive: true,
    rewards: { coins: 800, xp: 550 }
  },
  {
    id: 9018,
    name: "Diamond Cavern VIII",
    subtitle: "Starlight Summit",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "mango",
    targetEmoji: "🥭",
    targetCount: 50,
    moves: 28,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.20,
    obstacles: { type: "diamond", starlight: 8 },
    bgColor: "from-amber-900 via-yellow-800 to-orange-700",
    borderColor: "border-amber-300",
    memberExclusive: true,
    rewards: { coins: 850, xp: 575 }
  },
  {
    id: 9019,
    name: "Diamond Cavern IX",
    subtitle: "Aurora Arch",
    difficulty: "Expert",
    missionType: "clear_blockers",
    blockerType: "diamond_block",
    targetCount: 25,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.20,
    obstacles: { type: "diamond", diamond_block: 25, aurora: 6 },
    bgColor: "from-teal-900 via-cyan-800 to-sky-700",
    borderColor: "border-teal-300",
    memberExclusive: true,
    rewards: { coins: 900, xp: 600 }
  },
  {
    id: 9020,
    name: "Diamond Dragon",
    subtitle: "Second Boss",
    difficulty: "Boss",
    missionType: "boss_fight",
    bossConfig: {
      name: "Diamond Dragon",
      type: "diamond_dragon",
      hp: 1200,
      phases: 3,
      attacks: ["diamond_breath", "crystal_storm", "prism_devastation"]
    },
    moves: 45,
    boardSize: 10,
    worldMechanic: "lucky_drops",
    luckyChance: 0.25,
    bgColor: "from-sky-950 via-blue-900 to-indigo-800",
    borderColor: "border-sky-400",
    memberExclusive: true,
    rewards: { coins: 1500, xp: 750, stars: 50 }
  },
  
  // Levels M21-M35: Platinum Palace
  ...generatePlatinumPalaceLevels(),
  
  // Levels M36-M49: Celestial Sanctum
  ...generateCelestialSanctumLevels(),
  
  // Level M50: Final Boss - The Golden Phoenix
  {
    id: 9050,
    name: "The Golden Phoenix",
    subtitle: "Ultimate Challenge",
    difficulty: "Legendary",
    missionType: "boss_fight",
    bossConfig: {
      name: "Golden Phoenix",
      type: "golden_phoenix",
      hp: 3000,
      phases: 5,
      attacks: ["golden_flames", "radiant_burst", "phoenix_rebirth", "solar_inferno", "divine_judgment"]
    },
    moves: 60,
    boardSize: 10,
    worldMechanic: "golden_fruits",
    goldenChance: 0.30,
    bgColor: "from-yellow-500 via-amber-400 to-orange-500",
    borderColor: "border-yellow-300",
    memberExclusive: true,
    rewards: { coins: 5000, xp: 2000, stars: 200 }
  }
];

// Helper function to generate Platinum Palace levels (M21-M35)
function generatePlatinumPalaceLevels() {
  const levels = [];
  const difficulties = ["Expert", "Expert", "Expert", "Expert", "Expert", "Master", "Master", "Master", "Master", "Master", "Master", "Master", "Master", "Master", "Boss"];
  const fruits = ["grape", "cherry", "orange", "apple", "banana", "strawberry", "blueberry", "watermelon", "mango", "pear", "peach", "plum", "kiwi", "coconut", "star"];
  const emojis = ["🍇", "🍒", "🍊", "🍎", "🍌", "🍓", "🫐", "🍉", "🥭", "🍐", "🍑", "🫐", "🥝", "🥥", "⭐"];
  
  for (let i = 0; i < 15; i++) {
    const levelId = 9021 + i;
    const isLastBoss = i === 14;
    
    if (isLastBoss) {
      levels.push({
        id: levelId,
        name: "Platinum Emperor",
        subtitle: "Third Boss",
        difficulty: "Boss",
        missionType: "boss_fight",
        bossConfig: {
          name: "Platinum Emperor",
          type: "platinum_emperor",
          hp: 1800,
          phases: 4,
          attacks: ["platinum_slash", "metal_storm", "royal_decree", "imperial_fury"]
        },
        moves: 50,
        boardSize: 10,
        worldMechanic: "bonus_multiplier",
        bonusMultiplier: 1.5,
        bgColor: "from-slate-300 via-gray-200 to-zinc-100",
        borderColor: "border-slate-500",
        memberExclusive: true,
        rewards: { coins: 2000, xp: 1000, stars: 75 }
      });
    } else {
      levels.push({
        id: levelId,
        name: `Platinum Palace ${['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV'][i]}`,
        subtitle: ["Silver Entrance", "Golden Hall", "Jeweled Corridor", "Royal Chamber", "Throne Room", "Treasury", "Armory", "Garden", "Library", "Observatory", "Gallery", "Vault", "Sanctuary", "Pinnacle"][i],
        difficulty: difficulties[i],
        missionType: i % 3 === 0 ? "reach_score" : "collect_fruit",
        targetFruit: fruits[i],
        targetEmoji: emojis[i],
        targetScore: i % 3 === 0 ? 15000 + (i * 2000) : undefined,
        targetCount: i % 3 !== 0 ? 45 + (i * 3) : undefined,
        moves: 30 - Math.floor(i / 5),
        boardSize: 10,
        worldMechanic: "bonus_multiplier",
        bonusMultiplier: 1.5,
        obstacles: { type: "platinum", platinum_block: 8 + i },
        bgColor: "from-slate-400 via-gray-300 to-zinc-200",
        borderColor: "border-slate-400",
        memberExclusive: true,
        rewards: { coins: 1000 + (i * 75), xp: 625 + (i * 35) }
      });
    }
  }
  
  return levels;
}

// Helper function to generate Celestial Sanctum levels (M36-M49)
function generateCelestialSanctumLevels() {
  const levels = [];
  const difficulties = ["Master", "Master", "Master", "Master", "Master", "Legendary", "Legendary", "Legendary", "Legendary", "Legendary", "Legendary", "Legendary", "Legendary", "Boss"];
  
  for (let i = 0; i < 14; i++) {
    const levelId = 9036 + i;
    const isLastBoss = i === 13;
    
    if (isLastBoss) {
      levels.push({
        id: levelId,
        name: "Celestial Oracle",
        subtitle: "Fourth Boss",
        difficulty: "Boss",
        missionType: "boss_fight",
        bossConfig: {
          name: "Celestial Oracle",
          type: "celestial_oracle",
          hp: 2400,
          phases: 4,
          attacks: ["star_shower", "cosmic_wave", "celestial_binding", "supernova"]
        },
        moves: 55,
        boardSize: 10,
        worldMechanic: "star_power",
        starPowerChance: 0.15,
        bgColor: "from-indigo-950 via-purple-900 to-violet-800",
        borderColor: "border-indigo-400",
        memberExclusive: true,
        rewards: { coins: 3000, xp: 1500, stars: 100 }
      });
    } else {
      levels.push({
        id: levelId,
        name: `Celestial Sanctum ${['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII'][i]}`,
        subtitle: ["Star Gate", "Moon Chamber", "Sun Altar", "Cosmic Bridge", "Nebula Core", "Galaxy Path", "Constellation Hall", "Aurora Shrine", "Eclipse Tower", "Meteor Garden", "Comet Trail", "Supernova Vault", "Infinity Realm"][i],
        difficulty: difficulties[i],
        missionType: i % 2 === 0 ? "reach_score" : "collect_fruit",
        targetScore: i % 2 === 0 ? 25000 + (i * 2500) : undefined,
        targetFruit: i % 2 !== 0 ? ["grape", "cherry", "orange", "apple", "banana", "strawberry", "mango"][i % 7] : undefined,
        targetEmoji: i % 2 !== 0 ? ["🍇", "🍒", "🍊", "🍎", "🍌", "🍓", "🥭"][i % 7] : "⭐",
        targetCount: i % 2 !== 0 ? 60 + (i * 5) : undefined,
        moves: 32 - Math.floor(i / 4),
        boardSize: 10,
        worldMechanic: "star_power",
        starPowerChance: 0.10 + (i * 0.01),
        obstacles: { type: "celestial", star_block: 10 + i, void_cell: Math.floor(i / 2) },
        bgColor: "from-violet-950 via-indigo-900 to-blue-800",
        borderColor: "border-violet-400",
        memberExclusive: true,
        rewards: { coins: 1500 + (i * 100), xp: 800 + (i * 50) }
      });
    }
  }
  
  return levels;
}

// Export helper to check if a level is member-exclusive
export function isMemberLevel(levelId) {
  return levelId >= 9001 && levelId <= 9050;
}

// Export helper to get member world level by ID
export function getMemberLevelById(levelId) {
  return MEMBER_WORLD_LEVELS.find(level => level.id === levelId);
}
